/* eslint-disable */
'use strict';

const Contact = {
    init: function() {
        if (!window.location.pathname.includes('contact')) {
            return '';
        }

        this.bindChatEvents();
    },


    bindChatEvents: function() {
        document.querySelector('.js-trigger-giorgias-chat').addEventListener('click', function() {
            window.location.search = 'gs_open_chat';
        });
    }
}

export default Contact;